export const LICENCE_SUB_TYPE_ALL = "ALL"
export const LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION =
  "COLLECTION_AGENCY_APPLICATION";
export const LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL =
  "COLLECTION_AGENCY_RENEWAL";
export const LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_APPLICATION =
  "COLLECTION_COLLECTOR_APPLICATION";
export const LICENCE_SUB_TYPE_COLLECTION_COLLECTOR_RENEWAL =
  "COLLECTION_COLLECTOR_RENEWAL";
export const LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION =
  "DEBT_MANAGEMENT_APPLICATION";
export const LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION =
  "DEBT_MANAGEMENT_INDIVIDUAL_APPLICATION";
export const LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL =
  "DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL";
export const LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL =
  "DEBT_MANAGEMENT_RENEWAL";
export const LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION =
  "MORTGAGE_BROKERAGE_NEW_APPLICATION";
export const LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION =
  "PRINCIPAL_BROKER_NEW_APPLICATION";
export const LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION = 
    "MORTGAGE_BROKER_NEW_APPLICATION"
export const LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION = 
    "ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION"
export const LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION = "MORTGAGE_LENDER_NEW_APPLICATION"
export const LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION = "MORTGAGE_ADMINISTRATOR_NEW_APPLICATION"

export const LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION =
  "MORTGAGE_BROKERAGE_RENEWAL";
export const LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION =
  "PRINCIPAL_BROKER_RENEWAL";
export const LICENCE_SUB_TYPE_MORTGAGE_BROKER_RENEWAL_APPLICATION = 
    "MORTGAGE_BROKER_RENEWAL"
export const LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_RENEWAL_APPLICATION = 
    "ASSOCIATE_MORTGAGE_BROKER_RENEWAL"
export const LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION = "MORTGAGE_LENDER_RENEWAL"
export const LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION = "MORTGAGE_ADMINISTRATOR_RENEWAL"
export const LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION = "INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION"
export const LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION = "INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION"
export const LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION = "INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION"
export const LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION = "INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION"

export const LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION = "MORTGAGE_BROKERAGE_CHANGE_APPLICATION";
export const LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION = "MORTGAGE_LENDER_CHANGE_APPLICATION"
export const LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION = "MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION"